import KestrixEPCRating from './KestrixEPCRating.jsx';
import { colorTokens } from './tokens/colors.ts';

/**
 * Variants accepted by {@link KestrixEpcRatingChip}.
 *
 * Predicted ratings carry the Kestrix primary border to distinguish them from
 * lodged ratings (ticket 023); lodged keeps the default neutral border.
 */
export type KestrixEpcRatingChipVariant = 'lodged' | 'predicted';

export type KestrixEpcRatingChipProps = {
  rating: string | undefined;
  variant: KestrixEpcRatingChipVariant;
  size?: number;
  showBorder?: boolean;
};

const DEFAULT_BORDER_COLOR = '#e0e0e0';

const BORDER_COLOR_BY_VARIANT: Record<KestrixEpcRatingChipVariant, string> = {
  lodged: DEFAULT_BORDER_COLOR,
  predicted: colorTokens.global.primary[500],
};

/** Border colour for a lodged or predicted EPC chip — shared with dropdown EPC options. */
export const epcRatingBorderColor = (
  variant: KestrixEpcRatingChipVariant
): string => BORDER_COLOR_BY_VARIANT[variant];

/**
 * Single source of truth for rendering a lodged or predicted EPC rating.
 *
 * Thin wrapper over {@link KestrixEPCRating}. Use this everywhere lodged and
 * predicted EPC ratings are shown together so the visual language stays
 * consistent.
 */
export const KestrixEpcRatingChip = ({
  rating,
  variant,
  size = 24,
  showBorder = true,
}: KestrixEpcRatingChipProps) => {
  return (
    <KestrixEPCRating
      rating={rating ?? '-'}
      size={size}
      variant="box"
      showBorder={showBorder}
      borderColor={BORDER_COLOR_BY_VARIANT[variant]}
    />
  );
};
